import { FunctionalComponent, h } from 'preact';

export const EmailIcon: FunctionalComponent<{fill?: string}> = (props) => {
	const {fill = '#BFBFBF'} = props;

	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.5 2H1.5C0.671875 2 0 2.67188 0 3.5V12.5C0 13.3281 0.671875 14 1.5 14H14.5C15.3281 14 16 13.3281 16 12.5V3.5C16 2.67188 15.3281 2 14.5 2ZM1.5 3H14.5C14.775 3 15 3.225 15 3.5V4.79375C14.3156 5.37187 13.3375 6.16875 10.2937 8.58438C9.76562 9.00313 8.725 10.0125 8 10C7.275 10.0125 6.23125 9.00313 5.70625 8.58438C2.6625 6.16875 1.68438 5.37187 1 4.79375V3.5C1 3.225 1.225 3 1.5 3ZM14.5 13H1.5C1.225 13 1 12.775 1 12.5V6.09375C1.7125 6.67812 2.8375 7.58125 5.08437 9.36563C5.725 9.87813 6.85625 11.0063 8 11C9.1375 11.0094 10.2594 9.89063 10.9156 9.36563C13.1625 7.58125 14.2875 6.67812 15 6.09375V12.5C15 12.775 14.775 13 14.5 13Z"
				fill={fill}/>
		</svg>
	);
};
